exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".inCase {\n  width: 30px;\n  height: 30px;\n  background-color: #1d1f46;\n  display: inline-block;\n  border-radius: 30px;\n  padding-top: 2px;\n  position: absolute;\n  left: 14px;\n  top: 16px; }\n  .inCase svg {\n    fill: #fff; }\n\n.brief {\n  position: absolute;\n  left: 20px;\n  top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/shared/Briefcase/Briefcase.scss
// module id = 348
// module chunks = 0